import { Alert, AlertTitle, Avatar, Button, ButtonBase, FormControlLabel, List, ListItem, ListItemText, Switch, TextField } from "@mui/material";
import { WalletDialogButton, WalletDisconnectButton } from "@solana/wallet-adapter-material-ui";
import { useConnection, useLocalStorage, useWallet} from "@solana/wallet-adapter-react";
import { useCallback, useEffect, useRef, useState } from "react";
import request from "../api/request";
import { Gacha, Spin, Rabbit, GachaResult, Pay2Spin, Pay2SpinPrize, ClaimExtraSpin, Prize } from "../api/types";
import bs58 from 'bs58';
import { getBearerToken } from "../api/auth";
import './Gachapon.scss';
import { useLottie } from "lottie-react";
import GachaponMachine from "../components/GachaponMachine";
import RewardsList from "../components/RewardsList";
import LastSpins from "../components/LastSpins";
import Footer from "../components/Footer";
import RabbitSelector from "../components/RabbitSelector";
import GachaponResult from "../components/GachaponResult";
import GachaponError from "../components/GachaponError";
import exp from "../components/exp-table.json"
import whitelist from "../components/whitelist.json"
import { DateTime, Duration } from "luxon"
import relativeDuration from "../util/realtiveDuration";
import useSound from 'use-sound';
import scanRabbits from "../util/scanRabbits";
import { JsonMetadata } from "@metaplex-foundation/js";
import { WalletNotConnectedError  } from "@solana/wallet-adapter-base";
import { clusterApiUrl, Connection, LAMPORTS_PER_SOL, PublicKey, sendAndConfirmRawTransaction, sendAndConfirmTransaction, SignatureResult, SystemProgram, Transaction, TransactionInstruction } from "@solana/web3.js";
import CategorySpins, { Pay2SpinKeys } from "../components/CategorySpins";
import GachaponProcessing from "../components/GachaponProcessing";
import GachaponFragmentProcessing from "../components/GachaponFragmentProcessing";
import { getAssociatedTokenAddress, createTransferInstruction, TOKEN_PROGRAM_ID } from "@solana/spl-token";
import GachaponFragments from "../components/GachaponFragments";


const MuteButton = ({isMuted, setMute} : {isMuted:boolean, setMute:(muted:boolean) => void}) => {

  useEffect(() => {
    console.log(isMuted)
  }, [isMuted])

  return (
    <div className="Gachapon--Volume" onClick={() => { setMute(!isMuted) }}>
      {isMuted ? <img className="Gachapon--Volume--Mute" alt="" src="/images/mute.png" /> : <img alt="" className="Gachapon--Volume--Mute" src="/images/unmute.png" />}
    </div>
  )
}



const Gachapon = () => {
  const CLUSTER = process.env.REACT_APP_CLUSTER as 'devnet' | 'mainnet-beta';
  const RPC_ENDPOINT = process.env.REACT_APP_RPC || clusterApiUrl(CLUSTER);
  const RPC_WS_ENDPOINT = process.env.REACT_APP_RPC_WSS || clusterApiUrl(CLUSTER);
  const { connection } = useConnection();
  let { connected, signMessage, signTransaction, signAllTransactions, publicKey, sendTransaction, disconnect } = useWallet();
  let [authorization, setAuthorization] = useLocalStorage<string[]>('authorization', ['authorization', '']);
  
  let [showSelector, toggleSelector] = useState<boolean>(false)
  let [currentRabbit, setCurrentRabbit] = useState<Rabbit>()
  let [spinAllRabbit, setSpinAllRabbit] = useState<Rabbit>()
  let [isLevelUp, setLevelUp] = useState<boolean>(false)
  let [hasWonPrize, setWonPrize] = useState<any>()
  let [showError, setShowError] = useState<string>("")  
  
  // RABBIT SCAN
  let [walletRabbits, setWalletRabbits] = useState<any>([]);
  let [walletRabbit, setWalletRabbit] = request<string[]>('/wallet/rabbits?wallet='+publicKey?.toBase58(), {}, false);
  
  let [txId, setTxId] = useState<string>('');
  let [tokenPayment, setTokenPayment] = useState<string>('');
  let [rabbits, setRabbit] = request<Rabbit[]>('/rabbit/available?'+(new URLSearchParams({['mints[]']: walletRabbits.map((x: any) => x.mintAddress)})).toString(), {}, false);
  let [prizes, setPrizes] = request<Spin[]>('/gacha/spins', {}, true);
  let [allSpins, setAllSpins] = request<Spin[]>('/gacha/pay2spin/recent', { headers: [["Content-Type", "application/json"]], method: 'post', body: JSON.stringify({limit: 10})});
  let [gachitPrizes, setGachitPrizes] = request<Prize[]>('/prizes', {}, true);
  let [gachaResult, setGachaResult] = request<GachaResult>('/gacha', {headers: [authorization], method: 'post', body: JSON.stringify({rabbit: (currentRabbit) ? currentRabbit.mint : null})});
  let [gachaResultBulk, setGachaBulkResult] = request<GachaResult>('/gacha', {headers: [authorization], method: 'post', body: JSON.stringify({rabbit: (currentRabbit) ? currentRabbit.mint : null})});
  let [selectedPay2Spin, setSelectedPay2Spin] = useState<'pay2spin'|'tier2'|'diamond'|'gachapon'|'tier2023'>('tier2023');
  let [postPay2Spin, setPostPay2Spin] = request<Pay2SpinPrize>('/gacha/pay2spin', {headers: [authorization], method: 'post', body: JSON.stringify({tx_id: txId, tier: selectedPay2Spin === 'pay2spin'? '': selectedPay2Spin, rabbit: (currentRabbit) ? currentRabbit.mint : null, token: tokenPayment})});
  let [nextSpin, setNextSpin] = useState<any>("");
  let [pay2Spin, setPay2Spin] = request<Pay2Spin>('/gacha/pay2spin', {}, true);
  let [tier2Pay2Spin, setTierPay2Spin] = request<Pay2Spin>('/gacha/pay2spin?tier=tier2', {}, true);
  let [diamondPay2Spin, setDiamondPay2Spin] = request<Pay2Spin>('/gacha/pay2spin?tier=diamond', {}, true);
  let [gachaponPay2Spin, setGachaponPay2Spin] = request<Pay2Spin>('/gacha/pay2spin?tier=gachapon', {}, true);
  let [gachaponNewPay2Spin, setGachaponNewPay2Spin] = request<Pay2Spin>('/gacha/pay2spin?tier=tier2023', {}, true);
  let [extraSpinConfig, setExtraSpinConfig] = request<ClaimExtraSpin>('/claim/extra-spin', {}, true);
  let [postExtraSpins, setPostExtraSpins] = request<{success: boolean, error: any}>('/claim/extra-spin', {headers: [authorization], method: 'post', body: JSON.stringify({tx_id: txId, rabbit: (currentRabbit) ? currentRabbit.mint : null})});
  let [pay2SpinEnabled, setPay2SpinEnabled] = useState(false);
  
  let [showManualTx, setShowManualTx] = useState(false);
  let [currentPrice, setCurrentPrice] = useState(0);
  const [backgroundSound, backgroundSoundData] = useSound('/audio/homepage.mp3',{ volume: 0.05, loop: true });
  const [errorSound] = useSound('/audio/error.mp3', { volume: 0.03 });
  const [clickSound] = useSound('/audio/click.mp3', { volume: 0.03 });
  const[isBackgroundPlaying, setBackgroundPlaying ] = useState(false)
  const[isMuted, setMute ] = useState(false)
  const[isProcessingPayment, setProcessingPayment] = useState(false)
  const[isProcessingFragmentPayment, setProcessingFragmentPayment] = useState(false)
  const[isFragmentsSucess, setFragmentsSucess] = useState(false);
  
  let [usingLedger, setUsingLedger] = useLocalStorage<string>('usingLedger', 'false');

  const prevLedger = usePrevious(usingLedger)

  const[spinRabbitHistory, setSpinRabbitHistory] = useState<any>([]);

  let [transactionField, setTransactionField] = useState<Boolean>(false);
  let [transactionID, setTransactionID] = useState("");

  function usePrevious(value:any) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value; //assign the value of ref to the argument
    },[value]); //this code will run when the value of 'value' changes
    return ref.current; //in the end, return the current ref value.
  }
  
  const gachaMachineRef = useRef<any>();

  const pay2SpinMap = {
    pay2spin: pay2Spin,
    tier2: tier2Pay2Spin,
    diamond: diamondPay2Spin,
    gachapon: gachaponPay2Spin,
    tier2023: gachaponNewPay2Spin,
  }
  const currentPay2Spin = useCallback(() => {
    const current = pay2SpinMap[selectedPay2Spin];
    if (!current) return undefined;
    return current;
  }, [selectedPay2Spin, tier2Pay2Spin, pay2Spin, gachaponNewPay2Spin]);
    
    useEffect(() => {
      if (publicKey && publicKey !== undefined) { 
        // scanRabbits(publicKey!.toString()).then(rabbitNfts => {
          setWalletRabbit().then(rabbitNfts => {
            setWalletRabbits(rabbitNfts);
          });
          // setWalletRabbits(rabbitNfts);
        // });
      } else {
        setAuthorization(['authorization', ""]);
        setPrizes()
      }

      setPrizes()
      setAllSpins()
  
    }, [publicKey]);

    useEffect(() =>{ 
        setAuthorization(["authorization",""])
        setCurrentRabbit(undefined)
    }, [usingLedger])

    useEffect(() => {selectRabbit()}, [walletRabbits]);

    useEffect(() => {
      if (currentPay2Spin()?.available !== true) {
        setPay2SpinEnabled(false);
        setShowManualTx(false);
        setAuthorization(['authorization', '']);
       
      } else {

        var setPrice:any = (walletRabbits.length>0) ? currentPay2Spin()!.price * (1-currentPay2Spin()!.discount) :  currentPay2Spin()?.price
        setCurrentPrice(setPrice.toFixed(2))
      }
    }, [currentPay2Spin]);

    useEffect(() => {
      const intervalSpin = setInterval(() => {
        
        // var spinTime = DateTime.utc(DateTime.now().year,DateTime.now().month,DateTime.now().day-1,17,1).plus({days: 1}).diffNow().toObject()
        // var spinFragment:any = relativeDuration(spinTime, {isObject: true})
        // var spinLong:any = []
        // var spinShort:any = []
        // for(var f in spinFragment){
        //   var value = (parseInt(spinFragment[f]) < 10 && f==="minutes") ? `0${spinFragment[f]}` : spinFragment[f]
        //   var minFix = (spinShort.length===0 && f==="minutes") ? " mins" : (spinShort.length===0 && f=="hours") ? "" : " hrs"
        //   minFix = (f==="hours" && minFix === "" && spinFragment.hours > 0 && spinFragment.minutes === 0) ? " hrs" : minFix
        //   var longFix = (value > 1)? f : f.slice(0, -1)
        //   var shortFix = (value > 1)? minFix : minFix.slice(0, -1)
        //   if(value > 0){
        //     // spinLong.push(`${value} ${longFix}`);
        //     // spinShort.push(`${value}${shortFix}`)
        //     spinLong.push(`5PM UTC`);
        //     spinShort.push(`5PM UTC`)
        //   }
          
        // }
        // TODO: a better countdown
        setNextSpin({"long": `5 PM UTC`, short: `5 PM UTC`})

      }, 1000)
      const intervalPrizes = setInterval(() => {
        setPrizes()
      }, 60000)
      return () =>  { clearInterval(intervalSpin); clearInterval(intervalPrizes); }
    }, []);

    const showErrorMessage = (message:string) => {
      if(message!=="") { errorSound() }
      if(pay2SpinEnabled){
        setProcessingPayment(false)
      }
      setProcessingFragmentPayment(false)
      setShowError(message)
    }

    const isWhitelisted = (pubkey:string) => {
      if(whitelist.length === 0) { return true }
      let isWalletWhitelisted = whitelist.filter(wallet => { return wallet === pubkey })
      let returnValue = true
      if(isWalletWhitelisted.length === 0){
        errorSound()
        showErrorMessage("You don't have permission to access Flippin' Gach")
        returnValue = false;
      }
      return returnValue;
    }

    const playBackground = () => {
      if(!isBackgroundPlaying){
        backgroundSound()
        setBackgroundPlaying(true)
        console.log("bgOPay")
      }
    }
   
  const selectRabbit = useCallback(async () => { 
    if (walletRabbits.length > 0) { 
      await setRabbit();
      var setPrice:any = (walletRabbits.length > 0) ? currentPay2Spin()!.price * (1-currentPay2Spin()!.discount) :  currentPay2Spin()?.price
      setCurrentPrice(setPrice.toFixed(2))
    }
  }, [walletRabbits]);

  const getPrizeData = (response:any, rabbitAll:Rabbit|null = null) => {
    // console.log("prize", response, rabbitAll)
    const responseData = {image: "", name: "", type: response.type, currentRabbit: rabbitAll ? rabbitAll : currentRabbit}
    
     if(response.type.indexOf("exp_") === 0){
      responseData.image = `/thumbnails/${response.type}.png`
      let xpName = response.type.split("exp_")
      responseData.name = `${xpName[1]} EXP`
    } else if (response.type === "level_up"){
      responseData.image = `/thumbnails/level_up.png`
      responseData.name = `Level UP`
    } else if (response.type === "spl_token" || response.type === "cashback"){
      var tokenName = response.splToken
      responseData.image = `/thumbnails/spl_token.png`
      responseData.name = `${response.amount} ${tokenName}`
    } else if(response.mint){
      responseData.image = `${response.metadata.image}`
      responseData.name = response.metadata.name
    } else if (response.type === "wl_spot"){
      responseData.image = `/thumbnails/wl_spot.png`
      responseData.name = `WL token`
    } else if (response.type === "fragment"){
      responseData.image = `/thumbnails/fragment.png`
      responseData.name = `Spin fragment`
    }else if (response.type === "digital_good"){
      responseData.image = `/thumbnails/digital_good.png`
      responseData.name = `Digital Good`
    } else if (response.type === "raffle_ticket"){
      responseData.image = `/thumbnails/raffle_tickets.png`
      responseData.name = `Raffle Ticket`
    } else if (response.type === "pay2spin"){
      if(response.splToken) {
        let splName = response.splToken
        let splImage = "spl_token"
        switch (response.splToken) {
          case "FRRT":
            splName = "Raffle Ticket"
            splImage = "raffle_tickets"
            break;
          case "FRGS":
            splName = "Spin Token"
            splImage = "spin_token"
            break;
        
          default:
            splName = response.splToken
            splImage = "spl_token"
            break;
        }
        responseData.image = `/thumbnails/${splImage}.png`
        responseData.name = splName
      } else if (response.type === "raffle_ticket"){
        responseData.image = `/thumbnails/raffle_tickets.png`
        responseData.name = `Raffle Ticket`
      } else {
        let metadata = response.prize as JsonMetadata<string>
        responseData.image = metadata.image!;
        responseData.name = metadata.name!;
      }
    } else {
      responseData.image = `/thumbnails/flippinrabbits.png`
      responseData.name = "Gachapon Prize"
    }
    return responseData
  }

  const MEMO_PROGRAM_ID = new PublicKey(
    'MemoSq4gqABAXKb96qnH8TysNcWxMyWCqXgDLGmfcHr',
  );
  const buildAuthTx = (nonce: any): Transaction => {
    const tx = new Transaction();
    tx.add(
      new TransactionInstruction({
        programId: MEMO_PROGRAM_ID,
        keys: [],
        data: Buffer.from(nonce, 'utf8'),
      }),
    );
    // tx.add(
    //   SystemProgram.transfer({
    //     fromPubkey: publicKey!,
    //     toPubkey: publicKey!,
    //     lamports: LAMPORTS_PER_SOL / 1000,
    // })
    // );
    return tx;
  };
    
  async function login() {
    if(authorization[1] && authorization[1] !== '') return authorization[1]
    const message = `Authenticate wallet.`;
    let tokenAuth:any = false
    let sig:any = false
    let mode:string = usingLedger ==="false" ? "hot" : "cold"
    try{
      if(usingLedger==="false"){
        const encodedMessage = new TextEncoder().encode(message);
        let signedMessage: Uint8Array | false = false;
        if (signMessage) signedMessage = await signMessage(encodedMessage).catch(() => false);
        if (!signedMessage)  return false;
         sig = bs58.encode(signedMessage);
      } else {
        const tx = buildAuthTx(message);
        tx.feePayer = publicKey!;
        tx.recentBlockhash = (await connection.getLatestBlockhash()).blockhash;
        const signedTx = await signTransaction!(tx);
         sig = bs58.encode(signedTx.serialize());
      }

      tokenAuth = getBearerToken(publicKey!?.toBase58(), sig, mode)
      setAuthorization(['authorization', tokenAuth]);
    } catch(err:any) {
      if(err.message.indexOf("Cannot destructure property 'signature'") > -1){
        showErrorMessage(`If using Ledger, make sure to set "Alow Blind Sign" to true.`);
      } else {
        showErrorMessage(`Authentication failed`)
      }
    }

    return tokenAuth;
  }

  const refreshRabbit = async (rabbit:Rabbit) => {
      var newRabbits = await setRabbit()
      var newRabbit: Rabbit  = rabbit
      if(newRabbits){
        for (var n in newRabbits) {
          let r = newRabbits[n]
          if(r.mint === rabbit.mint){
            r.level = findLevel(r.exp)
            r.nextLevel = nextLevel(r.exp);
            newRabbit = r
            
          }
        }
      }
      return newRabbit
  }

  const getSolTransaction = useCallback(async (amount: number) => {
    if (!publicKey) throw new WalletNotConnectedError();
    if (!currentPay2Spin()?.payment_wallet) throw new Error('Pay 2 spin is offline');
    const hasRabbit = (rabbits || [])?.length > 0;
    const discount = currentPay2Spin()?.discount? (1 - (currentPay2Spin()?.discount || 0)): 1;
    const { blockhash, lastValidBlockHeight } = await connection.getLatestBlockhash("finalized");
    return new Transaction({
      blockhash: blockhash,
      lastValidBlockHeight: lastValidBlockHeight,
      feePayer: publicKey,
    }).add(
      SystemProgram.transfer({
        fromPubkey: publicKey,
        toPubkey: new PublicKey(currentPay2Spin()?.payment_wallet!),
        lamports: LAMPORTS_PER_SOL * amount * (hasRabbit? discount: 1),
      })
    );
  }, [publicKey, rabbits, currentPay2Spin]);

  const handlePayment: () => Promise<string> = useCallback(async() => {
    setProcessingPayment(true)
    
    if (currentPay2Spin()?.available !== true) return '';

    if (currentPay2Spin()?.mint) {
      return await tokenPurchaseP2S(currentPay2Spin()?.mint!, true);
    }

    return new Promise(async(res) => {
      if (!currentPay2Spin()?.price) throw new Error('Pay 2 spin is offline');
      setTokenPayment('')
      const transaction = await getSolTransaction(currentPay2Spin()?.price || 0);
      // const signature = await sendTransaction(transaction, connection).catch(() => undefined);
      const signature = await signTransaction!(transaction)

      const commitment: any = signature !== undefined? await sendAndConfirmRawTransaction(connection, signature.serialize(),{
        commitment:'finalized',
        preflightCommitment: "finalized",
        maxRetries: 20
      }) : undefined
      console.log(commitment)
      // const commitment = signature !== undefined? await connection.confirmTransaction(signature, 'confirmed'): undefined;
      if (commitment === undefined) {
        console.error("Could not process payment");
        res('');
        return;
      }
      
      let solConn = new Connection(RPC_ENDPOINT, { wsEndpoint: RPC_WS_ENDPOINT });
      solConn.onSignature(commitment!, (signatureResult: SignatureResult) => {
        if (signatureResult.err !== null) {
          console.error("Could not confirm payment!");
          res('');
          return;
        }
        setProcessingPayment(false)
        res(commitment!);
        setTxId(commitment!);
      });
    });
  }, [currentPay2Spin, connection, getSolTransaction, sendTransaction, RPC_ENDPOINT, RPC_WS_ENDPOINT]);

  const doPay2Spin = useCallback(async() => {
    var spinResponse = await setPostPay2Spin();
    setTxId('');
    if(spinResponse && (spinResponse.error)){
      var message = (spinResponse.error) ? spinResponse.error : "Your spin couldn't be processed. Click below and try again!"
      showErrorMessage(message);
      return;
    }

    await setWonPrize(getPrizeData(spinResponse));
    await setPrizes();
  }, [authorization, setGachaResult, getPrizeData, setPostPay2Spin, setPrizes, showErrorMessage]);
  
  const doSpin = useCallback(async() => {
    if (authorization[1] && pay2SpinEnabled) {
      setTokenPayment('');
      doPay2Spin();
      return;
    }

    if (!authorization[1] || !currentRabbit) return;
    const currentLevel = currentRabbit.level

    var spinResponse = await setGachaResult();
    if(spinResponse && (spinResponse.error || !spinResponse.type)){
      var message = (spinResponse.error) ? spinResponse.error : "Your spin couldn't be processed. Click below and try again!"
      showErrorMessage(message)
    } else {
      if(currentRabbit){
        var nextRabbit: Rabbit = await refreshRabbit(currentRabbit)
        if(currentLevel!==nextRabbit?.level){
          setLevelUp(true)
        }
      }
      await setWonPrize(getPrizeData(spinResponse))
      await setPrizes()
      setTimeout(() => {
        setCurrentRabbit(nextRabbit!)
      }, 500)
    }
  }, [authorization, setGachaResult, doPay2Spin, pay2SpinEnabled]);

  const getAssocTokenAddress = async (wallet: PublicKey, mint: PublicKey) => {
    const tokenAcc = await connection.getTokenAccountsByOwner(wallet, {mint: mint});
    return tokenAcc?.value[0]?.pubkey ?? null;
  };

  const getGenericSolTransaction = useCallback((amount: number, destination: string) => {
    if (!publicKey) throw new WalletNotConnectedError();
    return new Transaction().add(
      SystemProgram.transfer({
        fromPubkey: publicKey,
        toPubkey: new PublicKey(currentPay2Spin()?.payment_wallet!),
        lamports: LAMPORTS_PER_SOL * amount,
      })
    );
  }, [publicKey]);

  const getSplTransaction =  async (amount: number, mint: string, destination: string) => {
    if (!publicKey) throw new WalletNotConnectedError();

    const toPublicKey = new PublicKey(destination);
    const mintPk = new PublicKey(mint!);

    const fromTokenAccount = await getAssocTokenAddress(publicKey, mintPk);
    const toTokenAccount = await getAssocTokenAddress(toPublicKey, mintPk);

    if (fromTokenAccount === null || toTokenAccount === null) {
      throw new Error("Associated token not found!");
    }

    return new Transaction().add(
      createTransferInstruction(
        fromTokenAccount,
        toTokenAccount,
        publicKey,
        amount,
        [],
        TOKEN_PROGRAM_ID
      )
    );
  }

  const handleGenericPayment = useCallback(async(transaction: Transaction, isFragmentRedeem: boolean): Promise<string> => {
    // this is just a server health check, dont charge if server is potentially down
    let config = await setExtraSpinConfig().catch(err => null);
    if(isFragmentRedeem){
      setProcessingFragmentPayment(true)
    } else {
      setProcessingPayment(true)
    }
    if (!config) return '';

    return new Promise(async(res) => {
      const signature = await sendTransaction(transaction, connection).catch(() => undefined);
      if (!signature) {
        setProcessingPayment(false);
        return res('');
      }

      const commitment = signature !== undefined? await connection.confirmTransaction(signature, 'confirmed'): undefined;
      if (commitment === undefined || commitment?.value?.err !== null) {
        console.error("Could not process payment");
        return res('');
      }
      
      let solConn = new Connection(RPC_ENDPOINT, { wsEndpoint: RPC_WS_ENDPOINT });
      setTxId(signature!);
      solConn.onSignature(signature!, (signatureResult: SignatureResult) => {
        if (signatureResult.err !== null) {
          console.error("Could not confirm payment!");
          res('');
          return;
        }
        res(signature!);
        
      });
    });
  }, [connection, sendTransaction, RPC_ENDPOINT, RPC_WS_ENDPOINT]);

  const purchaseExtraSpin = useCallback(async(isFragmentRedeem: boolean) => {
    let signature: string = txId;
    if (!txId) {
      let transaction = isFragmentRedeem ? 
        await getSplTransaction(
          extraSpinConfig?.fragment_redeem_extra_spin.price!, 
          extraSpinConfig?.fragment_redeem_extra_spin.mint!, 
          extraSpinConfig?.claim_treasury!
        ): 
        getGenericSolTransaction(
          extraSpinConfig?.purchase_extra_spin.price!, 
          extraSpinConfig?.claim_treasury!
        )
      ;
      const sig = await handleGenericPayment(transaction, isFragmentRedeem);
      if (!sig) return showErrorMessage("Transaction failed.");
      signature = sig;
    }

    let result = await setPostExtraSpins({claim_type: isFragmentRedeem? 'fragment_redeem_extra_spin': 'purchase_extra_spin', tx_id: signature});
    if (!result || result?.error) {
      setProcessingPayment(false);
      setProcessingFragmentPayment(false);
      showErrorMessage(result?.error? result.error: 'Internal server error');
    } else {
      const nextRabbit:Rabbit = await refreshRabbit(currentRabbit!)
      setCurrentRabbit(nextRabbit)
      setProcessingFragmentPayment(false);
      setTxId('')
      setProcessingPayment(false);
      setFragmentsSucess(true)
    }
  }, [authorization, setPostExtraSpins]);

  const tokenPurchaseP2S = useCallback(async(token: string, useBasePayment: boolean = false) => {
    let signature: string = txId;
    if (!txId) {
      
      let transaction = 
        await getSplTransaction(
          useBasePayment? currentPay2Spin()?.price! * currentPay2Spin()?.decimals!: currentPay2Spin()?.payments[token]?.price! * currentPay2Spin()?.payments[token]?.decimals!, 
          useBasePayment? currentPay2Spin()?.mint!: currentPay2Spin()?.payments[token]?.mint!, 
          currentPay2Spin()?.payment_wallet!
        )
      ;
      const sig = await handleGenericPayment(transaction, false);
      if (!sig) {
        showErrorMessage("Transaction failed.");
        return '';
      }
      signature = sig;
    }
    setTokenPayment(token);
    setProcessingPayment(false);
    setTxId(signature);

    return signature;
  }, [authorization, currentPay2Spin]);

  const hideWallet = (wallet:string) => {
    return `${wallet.slice(0, 4)}...${wallet.substr(40,4)}`
  }

  const findLevel = (xp:number) => {
    var experience: { [key:string] : number} = exp
    var returnLevel = 1
    var objKeys = Object.keys(experience)
    for(var e in objKeys){
      const expNumber = Number(experience[objKeys[e]])
      if(expNumber <= xp){
        returnLevel = Number(objKeys[e])
      }
    }
    return returnLevel;
  }

  const nextLevel = (xp:number) => {
    var experience: { [key:string] : number} = exp
    var returnLevel = 1
    var objKeys = Object.keys(experience)
    for(var e in objKeys){
      const expNumber = Number(experience[objKeys[e]])
      if(expNumber <= xp){
        returnLevel = Number(objKeys[e])
      }
    }
    return experience[objKeys[returnLevel]];
  }
     

  let rewards = [
      {"src": "/nfts/07.png", locked: 14400 },
      {"src": "/nfts/06.png", locked: 14400 },
      {"src": "/nfts/08.png", locked: 14400 },
      {"src": "/nfts/09.png", locked: 14400 },
      {"src": "/nfts/01.png", locked: 10000 },
      {"src": "/nfts/02.png", locked: 10000 },
      {"src": "/nfts/03.png", locked: 10000 },
      {"src": "/nfts/04.png", locked: 10000 },
      {"src": "/nfts/05.png", locked: 10000 },
  ]

  const spinRabbit = async (rabbitMint:string, authorizationData: string) => {
    let bulkResult = await fetch(process.env.REACT_APP_API+'/gacha', {
      headers: [
        ['authorization', authorizationData],
        ['Accept', 'application/json'],
        ['Content-Type', 'application/json']
      ]
      , method: 'post', body: JSON.stringify({rabbit: (rabbitMint) ? rabbitMint : null})});
    return await bulkResult.json()
  }

  const spinHistory:any = []
  let spinAllTimeout:any = null

  const spinAllRabbits = async (authorizationData: string) => {
    if(!rabbits || rabbits.length === 0) return
    var availableRabbits = await setRabbit();
    // availableRabbits!.sort((a:any, b:any) => { return b.spins_remaining - a.spins_remaining})
    let toSpin = availableRabbits!.filter((r:any) => { return r.spins_remaining > 0})
    if(!toSpin || toSpin.length === 0) {
      setSpinAllRabbit(undefined)
      return
    } 
    setSpinAllRabbit(toSpin![0])
    let spinResult = await spinRabbit(toSpin![0].mint, authorizationData)
    let prizeResult = getPrizeData(spinResult, toSpin![0])
    // var availableRabbits = await setRabbit();
    spinHistory.unshift(prizeResult)
    setSpinRabbitHistory(spinHistory)
    spinAllTimeout = setTimeout(function() {
      spinAllRabbits(authorizationData)
    },5500)
  }
  
  const toFixed = (number:number, precision = 1) => {
    const factor = Math.pow(10, precision)
    return Math.floor(number * factor) / factor
  }
  
  const isDown = false

  const payWithToken = async (token: string) => {
    if(!currentRabbit && token === "FORGE") {
      showErrorMessage("You must select a rabbit!") 
      return;
    }
    setTokenPayment(token);
    let success = await tokenPurchaseP2S(token);
    if (success) gachaMachineRef?.current?.clickKnob();
  }
  
  let tokenPayments = pay2Spin?.payments? Object.keys(pay2Spin.payments).map((x, index) => {
    // let tokenPayment = pay2Spin?.payments[x];
    // console.log(tokenPayment, x)
    let btnTitle = (x === "PRNT") ? "" : "SPIN NOW"
    return  (
        <div key={index} style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
            <button onClick={() => { payWithToken(x) }} className={`Gacha--${x}`}>{btnTitle}</button>
            {x == "PRNT" ? <a className="buy-prnt" href="https://jup.ag/swap/SOL-PRNT" target="_blank"> <img src="https://jup.ag/svg/jupiter-logo.svg"/> <span>BUY $PRNT</span></a> : null }
        </div>
    )
}): [];
  
  return isDown ? (<div className="Gachapon--Wrapper">
    <div className="Gachapon--Header">
    <div className="Gachapon--Header--Logo">
              <img src={process.env.PUBLIC_URL + '/images/flippinrabbits-logo.png'} alt="" />
          </div>
    </div>
    <div className="Gachapon" style={{width: "100%", maxWidth: "600px", fontFamily: "GreatFriend"}}>
      <img style={{width:"100%", maxWidth: "400px", marginTop: "50px"}} src="./images/gacha-closed.png" alt="" />
    </div>
  </div>) : (
        <div className="Gachapon--Wrapper">

        <div className="Gachapon-Menu-Bar">
        <div className="Gachapon-Logo">
          <img src={process.env.PUBLIC_URL + '/images/flippinrabbits-logo.png'} alt="" />
        </div>
        <div className="Gachapon-Menu-Items">
        <div className="Gachapon--Header--Connect">
              
              {!connected &&  
                <WalletDialogButton className="Connect" color='warning' onClick={() => { clickSound() }} title="Connect wallet" >Connect Wallet</WalletDialogButton>
              }
              {connected && 
              <div className="Wallet-info">
                <div className="Gachapon--Header--Wallet">{publicKey ? `Hi, ${hideWallet(publicKey.toString())}` : ""}</div>
                
                  {!authorization[1] && pay2SpinEnabled !== true? <div className="Gachapon--Header--Select" onClick={async () => { 
                    clickSound();
                    let whitelisted = isWhitelisted(publicKey!.toString());
                    if(whitelisted){
                      
                      // RABBIT SCAN
                      // let scannedRabbits = await scanRabbits(publicKey!.toString());
                      // await setWalletRabbits(scannedRabbits);

                      if(rabbits && rabbits.length > 0) {
                        
                        toggleSelector(true) 
                      } else { 
                        showErrorMessage("You don't have any Flippin' Rabbits NFT.") 
                      } 
                    }
                  }}>Select Rabbit</div> :
                  <div className="Gachapon--Header--Select" onClick={async () => { 
                    clickSound();
                    let whitelisted = isWhitelisted(publicKey!.toString());
                    if(whitelisted){
                      
                      // RABBIT SCAN
                      // let scannedRabbits = await scanRabbits(publicKey!.toString());
                      // await setWalletRabbits(scannedRabbits);

                      if(rabbits && rabbits.length > 0) {
                        // playBackground()
                        toggleSelector(true) 
                      } else { 
                        showErrorMessage("You don't have any Flippin' Rabbits NFT.") 
                      } 
                    }
                  }}>Change Rabbit</div>}
                  
                  {connected && <div className="Gachapon--Header--Wallet">
                    <div onClick={() => {
                      let isLedger = usingLedger === "false" ? "true" : "false"
                      setUsingLedger(isLedger)
                      }} className={`Gachapon--Header--Wallet--Ledger ${usingLedger == "true" ? `active` : ``}`}>I'm using Ledger</div>
                    <WalletDisconnectButton startIcon={null} endIcon={null} className="Gachapon--Header--Disconnect" onClick={() => { clickSound(); disconnect();  }}  >Disconnect wallet</WalletDisconnectButton>
                  </div> }
                  
              </div>
              }
            </div>
        </div>
        <a href={`https://hub.flippinrabbits.xyz`} target={`_blank`}>Flippin HUB</a>
        <a href={`https://swap.flippinrabbits.xyz`}  target={`_blank`}>Swapper HUB</a>
        <a href={`https://flippinrabbits.xyz`}  target={`_blank`}>Website</a>
        
        
        </div>

           <RabbitSelector 
            showSelector={showSelector}
            spinAll={async(availableRabbits)=> {
              var verified:any = await login();
              if(verified) {
                setTimeout(function(){
                  spinAllRabbits(verified)
                }, 1500);
              }
            }}
            spinRabbitHistory={spinRabbitHistory}
            spinRabbit={spinAllRabbit}
            rabbits={rabbits} 
            hideSelector={() => { toggleSelector(false); clearTimeout(spinAllTimeout) }} 
            selectRabbit={async(rabbit:Rabbit | undefined) => { 
              var verified = await login(); 
              if(verified) {  
                rabbit!.level = findLevel(rabbit!.exp);
                rabbit!.nextLevel = nextLevel(rabbit!.exp);
                setCurrentRabbit(rabbit)
              } 
            }}
            nextSpin={nextSpin}
           />

           <GachaponResult p2sEnabled={pay2SpinEnabled} showPrize={hasWonPrize} hideResult={() => { setWonPrize(undefined); setLevelUp(false) }} isLevelUp={isLevelUp!} nextSpin={nextSpin} />
           <GachaponError errorMessage={showError} hideError={() => { showErrorMessage("") }} />
           {isProcessingPayment && <GachaponProcessing/>}
           {isProcessingFragmentPayment && <GachaponFragmentProcessing/>}
           <GachaponFragments showAnimation={isFragmentsSucess} closeFragments={() => { setFragmentsSucess(false) }} />

          <div className="Gachapon--Header">
            

            <div className="Gachapon--Header--Connect">
              <div className="Gachapon--Header--Logo">
                <img style={{transform: "translateY(-80%)"}} src={process.env.PUBLIC_URL + '/images/flippinrabbits-logo.png'} alt="" />
            </div>
              {!connected &&  
                <WalletDialogButton className="Connect" color='warning' onClick={() => { clickSound() }} title="Connect wallet" >Connect Wallet</WalletDialogButton>
              }
              {connected && 
              <div className="Wallet-info">
                <div className="Gachapon--Header--Wallet">{publicKey ? `Hi, ${hideWallet(publicKey.toString())}` : ""}</div>
                {currentRabbit && <div className="Gachapon--Header--Wallet rabbit" data-level={`LVL ${findLevel(currentRabbit.exp)}`}><img src={currentRabbit.metadata.image} alt=""/>{currentRabbit.metadata.name}</div>}
                  {!authorization[1] && pay2SpinEnabled !== true? <div className="Gachapon--Header--Select" onClick={async () => { 
                    clickSound();
                    let whitelisted = isWhitelisted(publicKey!.toString());
                    if(whitelisted){
                      
                      // RABBIT SCAN
                      // let scannedRabbits = await scanRabbits(publicKey!.toString());
                      // await setWalletRabbits(scannedRabbits);

                      if(rabbits && rabbits.length > 0) {
                        playBackground()
                        toggleSelector(true) 
                      } else { 
                        showErrorMessage("You don't have any Flippin' Rabbits NFT.") 
                      } 
                    }
                  }}>Select Rabbit</div> :
                  <div className="Gachapon--Header--Select" onClick={async () => { 
                    clickSound();
                    let whitelisted = isWhitelisted(publicKey!.toString());
                    if(whitelisted){
                      
                      // RABBIT SCAN
                      // let scannedRabbits = await scanRabbits(publicKey!.toString());
                      // await setWalletRabbits(scannedRabbits);

                      if(rabbits && rabbits.length > 0) {
                        playBackground()
                        toggleSelector(true) 
                      } else { 
                        showErrorMessage("You don't have any Flippin' Rabbits NFT.") 
                      } 
                    }
                  }}>Change Rabbit</div>}
                  {connected && <div className="Gachapon--Header--Wallet">
                  <div onClick={() => {
                      let isLedger = usingLedger === "false" ? "true" : "false"
                      setUsingLedger(isLedger)
                      }} className={`Gachapon--Header--Wallet--Ledger ${usingLedger == "true" ? `active` : ``}`}>I'm using Ledger</div>
                    <WalletDisconnectButton startIcon={null} endIcon={null} className="Gachapon--Header--Disconnect" onClick={() => { clickSound();  }}  >Disconnect wallet</WalletDisconnectButton>
                    </div> }
                  {(pay2Spin?.payments && pay2SpinEnabled && tokenPayments.length > 0) &&
                        tokenPayments
                    } 
                  {isBackgroundPlaying ? <MuteButton isMuted={isMuted} setMute={() => { setMute(!isMuted); if(isMuted) { backgroundSoundData.sound.play() }  else { backgroundSoundData.sound.pause()  } }} /> : null }
              </div>
              }
            </div>
          </div>
          {currentPay2Spin()?.available &&
            <div style={{display: 'none', alignItems: 'flex-start', width: '85%', minWidth: '1170px', justifyContent: 'space-between', flexDirection: 'column'}}>
              <FormControlLabel 
                control={
                  <Switch 
                    checked={pay2SpinEnabled} 
                    color='warning'
                    onChange={() => {
                      if (!pay2SpinEnabled) login();
                      setPay2SpinEnabled(!pay2SpinEnabled);
                    }}
                  />
                } 
                label="Enable Pay 2 Spin" 
              />
              {pay2SpinEnabled && 
                <FormControlLabel 
                  control={
                    <Switch 
                      checked={showManualTx} 
                      color='warning'
                      onChange={() => {
                        setShowManualTx(!showManualTx);
                      }}
                    />
                  } 
                  label="Input transaction manually" 
                />
              }
              {showManualTx &&
                <TextField 
                  label="Transaction" 
                  variant="filled" 
                  color="warning" 
                  value={txId}
                  onChange={(v) => setTxId(v.target.value)} focused style={{marginBottom: '1rem'}}
                />
              }
            </div>
          }
    
          <div className="Gachapon--Container">
            <div className="Gachapon--Container--Rewards">
              <RewardsList rewards={rewards} prizes={gachitPrizes} pay2SpinEnabled={pay2SpinEnabled} currentRabbit={currentRabbit!} />
            </div>
            <div className="Gachapon--Container--Machine">
                
                <GachaponMachine
                  nextSpin={nextSpin} 
                  onSpin={doSpin} 
                  isAuthorized={authorization[1]} 
                  currentRabbit={currentRabbit} 
                  showError={(message) => { showErrorMessage(message) }}
                  pay2SpinEnabled={pay2SpinEnabled}
                  price={currentPrice}
                  onPayment={handlePayment}
                  txId={txId}
                  onTxChange={(sig: string) => { setTokenPayment(''); setTxId(sig)}}
                  claimFragments={()=> {  purchaseExtraSpin(true); }}
                  ref={gachaMachineRef}
                  mint_name={currentPay2Spin()?.mint_name || ''}
                />
            </div>
             <div className="Gachapon--Container--Spins">
                <LastSpins lastSpins={prizes}/>
            </div>
            {((pay2SpinMap["pay2spin"] && pay2SpinMap["pay2spin"].available) || (pay2SpinMap["tier2"] && pay2SpinMap["tier2"].available) || (pay2SpinMap["diamond"] && pay2SpinMap["diamond"].available) || (pay2SpinMap["gachapon"] && pay2SpinMap["gachapon"].available)|| (pay2SpinMap["tier2023"] && pay2SpinMap["tier2023"].available))  && <div className="Gachapon--Switcher">
              <div className={`Gachapon--Switcher--Button--Containers`} onClick={() => { if (!pay2SpinEnabled) login(); setPay2SpinEnabled(true) }}>
                <img src="/images/coin_spin.png" className="Gachapon--Switcher--Button--Image coin" alt="Pay2Spin"/>
                <span className={`Gachapon--Switcher--Button  ${pay2SpinEnabled ? "active" : ""}`}>Gacha 2.0</span>
              </div>
              <div className={`Gachapon--Switcher--Button--Containers`} onClick={() => { setPay2SpinEnabled(false) }}>
                <img src="/images/rabbit_spin.png" className="Gachapon--Switcher--Button--Image " alt="FreeSpin"/>
                <span className={`Gachapon--Switcher--Button  ${!pay2SpinEnabled ? "active" : ""}`}>Rabbit Spins</span>
              </div>
            </div> }
             <div className="Gachapon--Rabbit">
             {currentRabbit && <div className="Gachapon--User">
                    <div className="Gachapon--User--Avatar">
                        <img src={(currentRabbit) ? currentRabbit.metadata?.image : ""} alt="" />
                    </div>
                    
                    <div className="Gachapon--User--Info">
                        <div className="Gachapon--User--Name">{(currentRabbit) ? currentRabbit.metadata?.name : ""}</div>
                        <div className="Gachapon--User--Level">{(currentRabbit) ? `LVL${currentRabbit.level}` : ""}</div>
                        <div className="Gachapon--User--XP" >
                            <span className="Gachapon--User--XP--Progress" style={{"width":0 + "%"}}></span>
                            <span className="Gachapon--User--XP--Level">Exp. {(currentRabbit) ? currentRabbit.exp : 0} / {(currentRabbit) ? currentRabbit.nextLevel : 0} </span>
                        </div>
                    </div>
                </div>}
                <div  className="Gachapon--User--Fragment">
                    {currentRabbit && extraSpinConfig && !pay2SpinEnabled &&
                        <div>
                            <img onClick={() => { purchaseExtraSpin(true) }} className="fragment-button" src={`/images/gachapon_fragment.png`} alt=""/>
                            <span className="extra-price">{extraSpinConfig?.fragment_redeem_extra_spin?.price} use Fragments</span>
                        </div>
                    }
                    {(pay2Spin?.payments && pay2SpinEnabled && tokenPayments.length > 0) &&
                        tokenPayments
                    }   
                </div>
                
            </div>
          </div>
          {false && connected && 
            <Footer 
              fragmentSpinPrice={(extraSpinConfig) ? extraSpinConfig?.fragment_redeem_extra_spin?.price : null} 
              extraSpinPrice={(extraSpinConfig) ? extraSpinConfig?.purchase_extra_spin?.price! : null} 
              claimFragments={(isFragment)=> {  purchaseExtraSpin(isFragment); }} 
              pay2SpinEnabled={pay2SpinEnabled} 
              rabbit={currentRabbit} 
              openSelector={() => { toggleSelector(true) }}
              pay2Spin={currentPay2Spin()}
              payWithToken={async (token: string) => { 
                let success = await tokenPurchaseP2S(token);
                if (success) gachaMachineRef?.current?.clickKnob();
              }}
            /> 
          }
           {((pay2SpinMap["pay2spin"] && pay2SpinMap["pay2spin"].available) || (pay2SpinMap["tier2"] && pay2SpinMap["tier2"].available) || (pay2SpinMap["diamond"] && pay2SpinMap["diamond"].available) || (pay2SpinMap["gachapon"] && pay2SpinMap["gachapon"].available) || (pay2SpinMap["tier2023"] && pay2SpinMap["tier2023"].available))  &&<div className="Gachapon--Recent">
          <div className="Gachapon--Recent-Title">Recent Gach-it spins</div>
          <div className="Gachapon--Recent-Header">
              <span>Wallet</span>
              <span>Spin type</span>
              <span>Prize</span>
              <span style={{visibility: "hidden"}}></span>
            </div>
          {allSpins?.map((recentSpin:any, index:number) => {
            var tierName = (recentSpin.tier && recentSpin.tier == "tier2023") ? "Gacha 2.0" : recentSpin.tier
            return <div className="Gachapon--Recent-Spin" key={index}>
              <span>{hideWallet(recentSpin.wallet)}</span>
              <span>{tierName ? tierName : "" } spin</span>
              <span>{recentSpin.amount ? toFixed(recentSpin.amount,4) + " SOL" : recentSpin.nft ? recentSpin.nft.metadata.name : "" }</span>
              <span>{DateTime.fromISO(recentSpin.createdAt).toRelative({style: "narrow"})}</span>
            </div>
          })}

          </div> }
          
        </div>
    )
}
export default Gachapon;